import Vue from "vue"
import VueI18n from "vue-i18n"
import en from "@/locales/en.json"

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  messages: { en }, // set locale messages
})

export default i18n
